import { PostfixCriteriaSchema } from 'api/apiTypes/postfixCriteria';
import { PostfixFunctionSchema } from 'api/apiTypes/postfixLogic';
import { z } from 'zod';

export const ApiSourceOfTruthTagRemovalUpdateCreateSchema = z.object({
  consentRuleId: z.string().optional(),
  isEnabled: z.boolean(),
  pageQualifier: PostfixFunctionSchema,
  // pageUrlMatchCriteria: PostfixLogicSchema,
  pageUrlMatchCriteria: PostfixCriteriaSchema.optional().nullable(),
  tagRequestTypeQualifier: z.union([PostfixFunctionSchema, PostfixCriteriaSchema]),
});

export const ApiSourceOfTruthTagRemovalCreateSchema = ApiSourceOfTruthTagRemovalUpdateCreateSchema.extend({
  ruleId: z.string(),
});

export const ApiSourceOfTruthTagRemovalSchema = ApiSourceOfTruthTagRemovalCreateSchema.extend({
  tagId: z.string(),
});

export type ApiSourceOfTruthTagRemoval = z.infer<typeof ApiSourceOfTruthTagRemovalSchema>;
export type ApiSourceOfTruthTagRemovalCreate = z.infer<typeof ApiSourceOfTruthTagRemovalCreateSchema>;
export type ApiSourceOfTruthTagRemovalUpdate = z.infer<typeof ApiSourceOfTruthTagRemovalUpdateCreateSchema>;
